export const CHANNEL_EMBED_TYPES = Object.freeze({
  ANYWHERE: "anywhere",
  DISABLED: "disabled",
  WHITE_LIST: "white_list",
});